module.exports = __webpack_public_path__ + "img/main_right.2ae72708.png";